export default __webpack_public_path__ + "static/media/10-min.008fb33c.jpg";